import { PRODUCTS_ACTIONS } from "constants/Actions/Products";

// Estado inicial del reducer
const aInitialState = {
    aProducts: [],
    aProductsList: [],
    nTotalPages: null,

    oProduct: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los productos almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que será seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const ProductReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case PRODUCTS_ACTIONS.GET:
            return { ...aState, aProducts: oAction.data.data, nTotalPages: oAction.data.pages };
        case PRODUCTS_ACTIONS.GET_LIST:
            return { ...aState, aProductsList: oAction.data.data, nTotalPages: oAction.data.pages };
        case PRODUCTS_ACTIONS.FIND:
            return { ...aState, oProduct: oAction.data };
        case PRODUCTS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case PRODUCTS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case PRODUCTS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oProduct: null };
        default:
            return aState;
    }
}
